import { t } from '../../utils/i18n';
import { categories, estimateInfo, hidePricing, procedures } from "../../utils/variables";

export function loadSelectedProcedures() {
    let list = document.querySelector(
        '.instant_quote_summary__container .list-selected-procedure__wrapper'
    );
    list.innerHTML = '';
    if (estimateInfo.line_items.length > 0) {
        list.insertAdjacentHTML(
                    'beforeend',
                    `
                        ${loadListProcedures(estimateInfo.line_items, estimateInfo.promotion)}
                `);
        feather.replace();

        const addOnsList = document.querySelectorAll('.summary__addons');
        if(addOnsList) {
            Array.from(addOnsList).forEach(element => {
                element.addEventListener('click' ,handleClickAddons);
            });
        }

    }
}

function handleClickAddons(event) {
   const element = event.currentTarget;
   const elementListAddons = element.querySelector('.list__addons');
   const elementWrapperAddons = element.querySelector('.addons__wrapper');

   let showAddons = elementWrapperAddons.classList.contains('show-addons-procedure');
   document.querySelectorAll('.show-addons-procedure').forEach(item => {
       item.classList.remove('show-addons-procedure');
       item.style.height  = '0px';
   });
   if(showAddons) {
       elementWrapperAddons.classList.add('show-addons-procedure');
       elementWrapperAddons.style.height  = elementListAddons.offsetHeight + 'px';
   }
   if(elementListAddons) {
       element.querySelector('.addons__wrapper').classList.toggle('show-addons-procedure');
       if(elementWrapperAddons.classList.contains('show-addons-procedure')) {
            elementWrapperAddons.style.height  = elementListAddons.offsetHeight + 'px';
       }else {
            elementWrapperAddons.style.height  = '0px';
       }
   }
}

function loadListProcedures(inlineLists, promotion) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    let list = '';
    if(promotion?.name) {
        list = list.concat(`
        <div class="summary__card">
            <div class="summary__info">
                <div class="category__img">
                    <i data-feather="tag"></i>
                </div>
                <div class="summary__content"> ${promotion.name}</div>
                ${ hidePricing ? '' : `
                    ${
                        promotion.min_savings === promotion.max_savings ||
                        promotion.max_savings === null
                            ? `
                        <div class="summary__note"> <span class="price savings">- $${
                            promotion.min_savings.toLocaleString('en-US')
                        }</span></div>`
                            : `<div class="summary__note"><span class="price">- $${
                                promotion.min_savings.toLocaleString('en-US')
                            }</span> <span class="to"> ${t('to')} </span> <span class="price savings">- $${promotion.max_savings.toLocaleString('en-US')}</span></div>`
                    }
                `}
            </div>
        </div>
        `);
    }
    for (const procedure of inlineLists) {
        let selectedProcedure = procedures.filter(i => i.name === procedure.name);

        let category = [];
        if (selectedProcedure && selectedProcedure.length > 0 && selectedProcedure[0].service_categories.length > 0) {
            category = categories.filter(c => c.name === selectedProcedure[0].service_categories[0]?.name);
        }

        list = list.concat(`
        <div class="summary__card">
            <div class="summary__info">
                <div class="category__img">
                    ${
                        category.length > 0 && category[0]?.icon
                            ? `
                    <img class="category__icon" src="${
                        process.env.GOOGLE_CLOUD_ICON_URL
                    }${category.length > 0 ? category[0]?.icon : undefined}">
                    `
                            : ''
                    }
                </div>
                <div class="summary__content summary__content-addons">
                    <span> ${procedure.name}</span>
                    ${
                        renderAddons(Object.values(procedure.addons))
                    }
                </div>
                ${ hidePricing ? '' : `
                    ${
                        procedure.min_cost === procedure.max_cost ||
                        procedure.max_cost === null
                            ? `
                        <div class="summary__note"> 
                            ${
                                procedure.min_cost === 0 
                                    ? `<span class="consult-required-for-estimate">${t('consultation_required')}</span>`
                                    : `<span class="price">$${procedure.min_cost.toLocaleString('en-US')}</span>`
                            }
                        ${procedure.savings_in_percent ? `<span class='savings__percent'>${procedure.savings_in_percent}% off</span>` : ''}</div>`
                            : `<div class="summary__note"><span class="price">$${
                                procedure.min_cost.toLocaleString('en-US')
                            }</span> <span class="to"> ${t('to')} </span> <span class="price">$${procedure.max_cost.toLocaleString('en-US')}</span>${procedure.savings_in_percent ? `<span class='savings__percent'>${procedure.savings_in_percent}% off</span>` : ''}</div>`
                    }
                `}
            </div>
        </div>
        `);
    }

    return list;
}

function renderAddons(addons) {
    if(addons?.length > 0) {
        return `
            <div class=${`summary__addons`}>
                <span class='addons__name'>${t('addons_count').replace('{count}', addons.length)}</span>
                <div class='addons__wrapper'>
                <div class='list__addons'>
                    ${
                        addons.map(item => `
                            <div class='item__addons'>
                            <i data-feather="circle"></i> <span>${item.name}</span>
                            </div>
                        `).join('')
                    }
                </div>
                </div>
            </div>
        `;
    }else {
        return '';
    }
}